module.exports = __webpack_public_path__ + "static/media/soccer-min.278fdf25.jpg";